@use "~@optimizely/design-tokens/dist/scss/colors";
@use "~@optimizely/design-tokens/dist/scss/typography";

:host {
    box-shadow: var(--axiom-dropshadow-small);
    background: #fff;
    border-radius: var(--axiom-border-radius-default);
    max-width: 272px;
    display: block;
    font-family: var(--axiom-font-families-inter);
}

.dropdown-list {
  &__name {
    font-size: typography.$font-sizes-xxs;
    height: 23px;
    color: colors.$block-list-text-header-color;
    letter-spacing: typography.$xxs-letter-spacing;
    padding: 0 0 0 10px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid colors.$block-list-divider-color;
    cursor: default;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }


  &__item {
    padding: 0 var(--axiom-space-small);
    font-size: typography.$body-font-size;
    border-bottom: 1px solid colors.$block-list-divider-color;
    position: relative;
    height: var(--axiom-dropdown-item-height);
    display: flex;
    align-items: center;
    justify-content: space-between;
    a {
      padding: 0 var(--axiom-space-small);
      width: 100%;
    }
    button {
      background: transparent;
      border: none;
      width: 100%;
      padding: 0 var(--axiom-space-small);
      font-size: typography.$body-font-size;
      &:hover {
        cursor: pointer;
      }
    }

    &:not(.dropdown-list__item--overflow) {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &:last-child {
      border: 0;
    }

    &--selected {
      color: colors.$alert-brand-text-color;

      &:hover {
        cursor: default;
      }
    }

  }


  &__item-text {
    padding: 0 var(--axiom-space-small);
  }

  &__item-link {
    text-decoration: none;
    color: colors.$link-default-text-color;
    letter-spacing: typography.$subhead-letter-spacing;
    line-height: typography.$subhead-line-height;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 200px;
    box-sizing: border-box;
    &:hover {
      background-color: colors.$brand-blue-extra-light;
      border-radius: var(--axiom-border-radius-default);
    }
    &--truncated {
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    svg {
      margin-left: 8px;
    }
  }


  &__submenu {
    display: none;
    position: absolute;
    left: 100%;
    width: 100%;
    box-shadow: var(--axiom-dropshadow-small);
    margin-left: 1px; /* offset for dropdshadow */
    background: #fff;
    border-radius: var(--axiom-border-radius-default);
    min-width: 200px;
    box-sizing: border-box;
    top: -24px;
  }

}


ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

*:focus-within > .dropdown-list__submenu {
  display: block;
}

li.dropdown-list__no-results {
  color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 0 28px 0; // per ux
  font-size: typography.$font-sizes-subhead;
}
